import { HistoryEvent } from '@api/types';
import { nameStartsWith } from '@react/constants/historyEvent/utils';

export function userParser(event: HistoryEvent) {
  return nameStartsWith(event, 'accounts:user');
}
